module.exports = __webpack_public_path__ + "static/media/signature_exuus.2dc95ca6.svg";